module.exports = __webpack_public_path__ + "img/sendInvitationLink.fb067f3c.svg";